import { stringNormalize } from 'quill-string-normalizer'

export default function() {
  return stringNormalize(this)
}
